module.exports = __webpack_public_path__ + "static/media/padlock-icon.99e24881.svg";